import { render, staticRenderFns } from "./RegisterDevice.vue?vue&type=template&id=6f5bf4eb&scoped=true&"
import script from "./RegisterDevice.vue?vue&type=script&lang=ts&"
export * from "./RegisterDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5bf4eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5bf4eb')) {
      api.createRecord('6f5bf4eb', component.options)
    } else {
      api.reload('6f5bf4eb', component.options)
    }
    module.hot.accept("./RegisterDevice.vue?vue&type=template&id=6f5bf4eb&scoped=true&", function () {
      api.rerender('6f5bf4eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/RegisterDevice.vue"
export default component.exports